/**
 * Attachment upload limits, supported types, and status endpoint.
 *
 * Split out of utils/Constants.js (roadmap Module 8) — Constants.js remains
 * a re-export shim until import sites migrate to "src/constants/attachments".
 */
const BASE_ENDPOINT = process.env.REACT_APP_BACKEND_BASE_ENDPOINT;
export const ENDPOINT_CHECK_ATTACHMENT_STATUS = `${BASE_ENDPOINT}/api/attachment/status`;

export const SHOW_USER_UPLOADED_DOCS_IN_LIBRARY = false;
// export const SHOW_DOWNLOAD_BUTTON_WITH_USER_UPLOADED_DOC

// File upload constants — tier-aware attachment caps (server is authoritative;
// these are fallbacks for chats with no attachment messages yet).
export const FREE_ATTACHMENT_LIMIT = 10;
export const PAID_ATTACHMENT_LIMIT = 30;

// Supported attachment file extensions (lowercase, no leading dot).
// MUST mirror the backend allowlist enforced on POST /api/get-presigned-upload-url
// (.pdf, .docx, .jpg, .jpeg, .png) — the backend keys file type off the filename
// extension and returns a 422 for anything outside this list. Keep in sync.
export const SUPPORTED_ATTACHMENT_EXTENSIONS = ["pdf", "docx", "jpg", "jpeg", "png"];

// `accept` attribute for the file-picker input. Extensions are the authoritative
// gate (re-validated in handleFileChange); the MIME hints only refine the OS dialog.
// DOCX has no reliable single MIME across OSes, so its extension carries it.
export const ATTACHMENT_ACCEPT_ATTR = ".pdf,.docx,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png";
